// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2hvKq","options":"AnswerScale_options__33POB","selected":"AnswerScale_selected__1mQfP"};